import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { AppError } from '../../types/error';
import { AsyncThunkConfig } from '../../types/utility';
import { chooseBank } from '../thunks/bank-selection.thunk';
import { ErrorKey, FincredibleBankException } from '../../types/exceptions';

type State = (AppError & { raised: true }) | { raised: false };

const initialState = { raised: false } as State;

export const errorSlice = createSlice({
	name: 'error',
	initialState,
	reducers: {
		saveError(_, action: PayloadAction<AppError>) {
			return { ...action.payload, raised: true };
		}
	},
	extraReducers: (builder) => {
		builder.addCase(chooseBank.rejected, (state, error) => {
			const payload = error.payload as
				| {
						errorKey: ErrorKey;
						context?: any;
						reference?: string;
						traceId?: string;
				  }
				| undefined;
			return {
				type: payload?.errorKey || 'TECHNICAL',
				extra: payload?.context,
				reason: payload
					? new FincredibleBankException(
							payload?.errorKey || 'BANK_INTEGRATION_EXCEPTION',
							payload?.context,
							payload.reference,
							payload.traceId
					  )
					: new Error(JSON.stringify(error.error)),
				raised: true,
				reference: payload?.reference,
				traceId: payload?.traceId
			};
		});
	}
});

export const errorActions = errorSlice.actions;

export const reportError = createAsyncThunk<void, AppError, AsyncThunkConfig>(
	'error/report',
	async (error, { dispatch }) => {
		if (error.reason instanceof FincredibleBankException) {
			dispatch(
				errorActions.saveError({
					type: error.reason.errorKey,
					extra: error.reason.context,
					reason: error.reason,
					reference: error.reason.reference,
					traceId: error.reason.traceId
				})
			);
			return;
		}
		dispatch(errorActions.saveError(error));
	},
	{
		dispatchConditionRejection: false
	}
);

export const selectError = (state: RootState) => state.error;
